module.exports = __webpack_public_path__ + "img/switch-horizontal-02.a095f7e3.svg";